import { useTranslation } from 'react-i18next'

import { Text, TextAreaRichEditor } from '@reveni-io/reveni-ui'

import InsertVariables from '@/common/components/InsertVariables/InsertVariables'
import { getEmailVariables } from '@/common/helpers/helpers'

import usePreheader from './hooks/usePreheader/usePreheader'
import { preheaderMaxLength } from './constants'
import * as Styles from './styles'

const Preheader = ({ preheader, onChangePreheader, availableVariables, availableSections, disabled }) => {
  const { t } = useTranslation()
  const { editorRef, preheaderLength, handleChangePreheader, onAddVariable } = usePreheader({
    preheader,
    onChangePreheader,
  })

  return (
    <Styles.Container>
      <Text type="titleS">{t('Texto de vista previa (opcional)')}</Text>
      <Styles.InputContainer>
        <Styles.FieldContainer>
          <TextAreaRichEditor
            fullWidth
            textType="html"
            inputType="text"
            value={preheader}
            onChange={handleChangePreheader}
            label={t('Texto de vista previa')}
            variables={getEmailVariables(availableVariables)}
            editorRef={editorRef}
            disabled={disabled}
          />
          <Styles.Hint>
            <Text type="bodyXSRegular">
              {t(
                'Se muestra junto al asunto en la bandeja de entrada. Si lo dejas vacío, usamos el inicio del email. Pon primero las palabras más importantes.'
              )}
            </Text>
            <Text type="bodyXSRegular">{`${preheaderLength}/${preheaderMaxLength}`}</Text>
          </Styles.Hint>
        </Styles.FieldContainer>
        <InsertVariables
          onAddVariable={onAddVariable}
          availableVariables={availableVariables}
          availableSections={availableSections}
          disabled={disabled}
          tooltip={t(
            'Inserta variables en tu texto para añadir contenido dinámico como nombres, números de referencia, valores, etc. en tus correos.'
          )}
        />
      </Styles.InputContainer>
    </Styles.Container>
  )
}

export default Preheader
